/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

// You can replace this with your actual logo import
// import Logo from "../static/logo.png";

export interface OmniverseHeaderProps {
  user?: {
    givenName?: string;
    familyName?: string;
    email?: string;
  };
  onLogout?: () => void;
}

export default function OmniverseHeader({
  user,
  onLogout,
}: OmniverseHeaderProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSessionsClick = () => {
    if (location.pathname !== '/omniverse/sessions') {
      window.open('/omniverse/sessions', '_blank');
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        color: 'primary.main',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: ({ spacing }) => spacing(6),
        px: ({ spacing }) => spacing(1.6),
        borderBottom: 1,
        borderColor: ({ alpha, palette }) => alpha(palette.neutral.main, 0.1),
        zIndex: ({ zIndex }) => zIndex.appBar,
        position: 'sticky',
        top: 0,
      }}
    >
      <NavLink to={'/omniverse'} style={{ textDecoration: 'none' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* <img src={Logo} width={40} height={40} alt="Logo" /> */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'primary.main',
              textTransform: 'uppercase',
              fontSize: '1.25rem',
            }}
          >
            Omniverse Streaming
          </Typography>
        </Box>
      </NavLink>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="text"
          startIcon={<DesktopWindowsOutlinedIcon />}
          onClick={handleSessionsClick}
          disabled={location.pathname === '/omniverse/sessions'}
          sx={{
            color: 'primary.main',
            textTransform: 'none',
            px: 2,
            '&:hover': {
              backgroundColor: ({ alpha, palette }) =>
                alpha(palette.primary.main, 0.08),
            },
            '&.Mui-disabled': {
              color: ({ alpha, palette }) =>
                alpha(palette.primary.main, 0.5),
            },
          }}
        >
          Sessions
        </Button>
      </Box>
    </Box>
  );
}
